gsap.registerPlugin(ScrollTrigger);

// ===============================================
// ヘルパー
// ===============================================
const ease = {
  out:   'power3.out',
  inOut: 'power4.inOut',
  soft:  'power2.out',
};

// スクロールトリガー生成
const st = (trigger, start = 'top 80%') => ({
  trigger,
  start,
  once: true,
});


// ===============================================
// ヘッダー
// ===============================================

// 背景パララックス
gsap.to('.lower-head--company', {
  backgroundPositionY: '35%',
  ease: 'none',
  scrollTrigger: {
    trigger: '.lower-head--company',
    start: 'top top',
    end: 'bottom top',
    scrub: 1,
  },
});

// ヘッダーテキスト
gsap.from('.lower-head_txt', {
  opacity: 0,
  y: 30,
  duration: 1.1,
  delay: 0.4,
  ease: ease.out,
});


// ===============================================
// FOODTECとは
// ===============================================

gsap.from('.heading-ptn-01', {
  opacity: 0,
  y: 40,
  duration: 1,
  ease: ease.out,
  scrollTrigger: st('.heading-ptn-01'),
});

gsap.from('.company_about_heading span', {
  opacity: 0,
  y: 30,
  stagger: 0.2,
  duration: 0.9,
  ease: ease.out,
  scrollTrigger: st('.company_about_heading'),
});

gsap.from('.company_about_txt', {
  opacity: 0,
  y: 20,
  duration: 0.9,
  ease: ease.soft,
  scrollTrigger: st('.company_about_txt'),
});

// メーカー画像 - 左から右へリビール
gsap.from('.company_about_maker_img', {
  clipPath: 'inset(0 100% 0 0)',
  duration: 1.4,
  ease: ease.inOut,
  scrollTrigger: st('.company_about_maker', 'top 75%'),
});

// メーカーテキストボックス
gsap.from('.company_about_maker_contents', {
  opacity: 0,
  x: 30,
  duration: 0.9,
  delay: 0.5,
  ease: ease.out,
  scrollTrigger: st('.company_about_maker', 'top 75%'),
});


// ===============================================
// 強み 01 / 02 / 03
// ===============================================

gsap.utils.toArray('.sec-feature_item').forEach((item) => {
  const num      = item.querySelector('.sec-feature_num');
  const heading  = item.querySelector('.sec-feature_heading');
  const subtitle = item.querySelector('.sec-feature_subtitle');
  const txt      = item.querySelector('.sec-feature_txt');
  const img      = item.querySelector('.sec-feature_img');
  const svcImg   = item.querySelector('.sec-feature_service_img');

  const tl = gsap.timeline({
    scrollTrigger: { trigger: item, start: 'top 78%', once: true },
  });

  if (num)      tl.from(num,      { opacity: 0, y: -20, duration: 0.65, ease: ease.out });
  if (heading)  tl.from(heading,  { opacity: 0, y: 25,  duration: 0.7,  ease: ease.out  }, '-=0.3');
  if (subtitle) tl.from(subtitle, { clipPath: 'inset(0 100% 0 0)', duration: 0.85, ease: ease.inOut }, '-=0.2');
  if (txt)      tl.from(txt,      { opacity: 0, y: 20,  duration: 0.7,  ease: ease.soft }, '-=0.35');
  if (img)      tl.from(img,      { clipPath: 'inset(0 100% 0 0)', duration: 1.1, ease: ease.inOut }, '-=0.3');
  if (svcImg)   tl.from(svcImg,   { clipPath: 'inset(0 100% 0 0)', duration: 1.2, ease: ease.inOut }, '-=0.4');
});


// ===============================================
// Company Profile
// ===============================================

// バナー
gsap.from('.company_profile_head', {
  clipPath: 'inset(0 100% 0 0)',
  duration: 0.9,
  ease: ease.inOut,
  scrollTrigger: st('.company_profile_head'),
});

// ご挨拶 - 画像とテキストを同時スタート
const greetingTl = gsap.timeline({
  scrollTrigger: st('.company_profile_greeting', 'top 75%'),
});

greetingTl
  .from('.company_profile_greeting_heading', { opacity: 0, y: 30, duration: 0.8, ease: ease.out })
  .from('.company_profile_greeting_img',     { clipPath: 'inset(0 0 100% 0)', duration: 1.3, ease: ease.inOut }, '<')
  .from('.company_profile_greeting_txt',     { opacity: 0, y: 20, duration: 0.9, ease: ease.soft }, '<0.3')
  .from('.company_profile_greeting_sign',    { opacity: 0, x: 20, duration: 0.6, ease: ease.soft }, '>-0.4');

// 会社概要 見出し
gsap.from('.company_profile_overview_heading', {
  opacity: 0,
  y: 30,
  duration: 0.8,
  ease: ease.out,
  scrollTrigger: st('.company_profile_overview_heading'),
});

// テーブル各行をスタガーで
gsap.utils.toArray('.company_profile_overview_item').forEach((item, i) => {
  gsap.from(item, {
    opacity: 0,
    y: 15,
    duration: 0.55,
    ease: ease.soft,
    delay: i * 0.07,
    scrollTrigger: { trigger: item, start: 'top 88%', once: true },
  });
});


// ===============================================
// 特徴 リード文
// ===============================================

gsap.from('.features_head_txt', {
  opacity: 0,
  y: 20,
  duration: 0.9,
  ease: ease.soft,
  scrollTrigger: st('.features_head_txt'),
});


// ===============================================
// 特徴 パネル
// ===============================================

gsap.utils.toArray('.cmp-panel_item').forEach((item, i) => {
  gsap.from(item, {
    opacity: 0,
    y: 30,
    duration: 0.7,
    ease: ease.out,
    scrollTrigger: { trigger: item, start: 'top 85%', once: true },
    delay: (i % 2) * 0.15,
  });
});


// ===============================================
// ネオ和菓子 キャッチコピー・バー画像
// ===============================================

gsap.from('.sec-feature_catch', {
  opacity: 0,
  y: 30,
  duration: 1,
  ease: ease.out,
  scrollTrigger: st('.sec-feature_catch'),
});

gsap.from('.sec-feature_subtitle-img', {
  clipPath: 'inset(0 100% 0 0)',
  duration: 1.2,
  ease: ease.inOut,
  scrollTrigger: st('.sec-feature_subtitle-img', 'top 80%'),
});


// ===============================================
// ネオ和菓子 01 フレックスアイテム
// ===============================================

gsap.utils.toArray('.sec-feature_flex_item').forEach((item) => {
  const thumb    = item.querySelector('.sec-feature_flex_item_thumb');
  const contents = item.querySelector('.sec-feature_flex_item_contents');

  const tl = gsap.timeline({
    scrollTrigger: { trigger: item, start: 'top 80%', once: true },
  });

  if (thumb)    tl.from(thumb,    { opacity: 0, y: 25, duration: 0.9, ease: ease.out });
  if (contents) tl.from(contents, { opacity: 0, y: 20, duration: 0.7, ease: ease.soft }, '-=0.4');
});
